var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_c(_vm.$options.components.IconSvg,_vm._g(_vm._b({ref:_vm.data.ref,tag:"component",class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"icon":_vm.props.variant}},'component',_vm.data.attrs,false),_vm.listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }